import { Component } from "@angular/core";
import { Broadcaster } from "../../service/Broadcaster";
import { SingService } from "../../service/sing.service";
import { ActivatedRoute } from "@angular/router";
import { DashboardUpMenu } from "./services/dashboard-up-menu.service";
import { Dashboard } from "app/components/class/dashboard/dashboard";
import { responseGetDashboard } from "app/components/class/http/res/response-get-dashboard";
@Component({
    selector: "dashboard-up-menu-comp",
    templateUrl: "html/dashboard-up-menu.component.html",
    styleUrls: ["css/dashboard-up-menu.component.min.css"],
    providers: [SingService,DashboardUpMenu]
})
export class DashboardUpMenuComponent {
    sub: any;
    menuDashboards:Array<Dashboard> = [];
    

    constructor(
        private broadcaster: Broadcaster,
        private httpService: SingService,
        private route: ActivatedRoute,
        private actions:DashboardUpMenu
    ) { }
    ngOnInit() {
        if (this.httpService.getAuthData().loggedIn !== "") {
            this.sub = this.route.queryParams.subscribe(params => {
                this.actions.dealerGroupId = +params["id"] || 0;
              
                this.actions
                    .getDashboard()
                    .subscribe((data:responseGetDashboard) => {
                    
                            this.menuDashboards = data.list
                            if (this.menuDashboards.length > 0) {
                                this.broadcaster.broadcast("showDasboard", this.menuDashboards[0]);
                            }
                   
                    });

            });
        }
        else {
            window.location.href = "/";
        }

    }
    trackByIndex(index, item) {
        return index;
    }
    SelectDashboard(i: number, event: any) {
        event.preventDefault();
       this.actions.SelectDashboard(i,event);
        this.broadcaster.broadcast("showDasboard", this.menuDashboards[i]);
    }

    UpdateFirstDashboard(id: number): string {

        if (id === 0) {
            return "m--active";
        }
        return "";
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/up-menu/dashboard-up-menu.component.ts